import { TripBookColor } from '51trips-frontend-core'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export type ConfigState = { colors: TripBookColor[] } | null | undefined
export const configAtom = atom<ConfigState>({ colors: [] })

// Market the user came through — seeded from the agency's primary market or the
// landing page's `mkt` query param (e.g. "840"/US, "826"/UK), and recorded on the
// user doc when the account is registered. atomWithStorage persists it to
// localStorage so it survives the onboarding's navigations and OAuth round-trips.
export const marketAtom = atomWithStorage<string | undefined>('market', undefined)

export type InvitationState = any | null | undefined
export const invitationAtom = atom<InvitationState>(undefined)
/*
discount is percentage discount, for example -20%
 */
export type PromoCodeState = { code: string; discount: string } | null | undefined
export const promoCodeAtom = atom<PromoCodeState>(undefined)
